import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

import Config from '@/config'
import auth from './auth/authStore'
import flags from './flags/flagsStore'
import notification from './notification/notificationStore'
import system from './system/systemStore'
import filters from './filters/filtersStore'

Vue.use(Vuex)

const vuexPersist = new VuexPersistence(Config.vuexPersist)

export default new Vuex.Store({
    modules: {
        auth,
        flags,
        notification,
        system,
        filters,
    },
    plugins: [vuexPersist.plugin],
})
